// extracted by mini-css-extract-plugin
export default {"mnImageDetailOperationView":"index_mnImageDetailOperationView__-308l","img-actions":"index_img-actions__lkX0Q","action-pagination":"index_action-pagination__7SYaB"};